import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { NavigateFunction } from "react-router-dom";

class CoreNavigationStore {
  navigate = observable.box<NavigateFunction>();

  setNavigate = (navigate: NavigateFunction) => {
    runInAction(() => {
      this.navigate.set(navigate);
    });
  };

  navigateToPage = (pathname: string, search: string) => {
    this.navigate.get()({ pathname, search });
  };

  setURLSearchID = (id: number) => {
    this.navigateToPage(window.location.pathname, `?id=${id}`);
  };
}

const getCoreNavigationStore = memoize(
  () => new CoreNavigationStore(),
  () => 1
);
export default getCoreNavigationStore;
